export const signInFlowKey="pirdy.signin.flow.v1";
export const signInLifetimeMs=30*60*1000;
export function validSignInFlow(flow,now=Date.now()) {
  return Boolean(flow&&/^[a-f0-9]{64}$/.test(flow.state??"")&&Number.isFinite(flow.started)&&now>=flow.started&&now-flow.started<signInLifetimeMs);
}
export function nativeAuthorizeTarget(value,allowedClients) {
  const url=new URL(value);
  if(url.protocol!=="https:"||url.hostname!=="pirdy.ciamlogin.com"||url.port||url.username||url.password||url.hash||
     !/^\/(?:7baccdd2-d5de-442d-bbff-d3b3fd5e92b3|pirdy\.onmicrosoft\.com)\/oauth2\/v2\.0\/authorize\/?$/i.test(url.pathname)||
     !allowedClients.includes(url.searchParams.get("client_id"))||url.searchParams.get("response_type")!=="code"||
     url.searchParams.get("code_challenge_method")!=="S256"||!url.searchParams.get("code_challenge")||!url.searchParams.get("state"))
    throw new Error("This app sign-in request is invalid. Return to Pirdy and try again.");
  const redirect=new URL(url.searchParams.get("redirect_uri"));
  if(redirect.protocol!=="http:"||!["localhost","127.0.0.1"].includes(redirect.hostname)||redirect.username||redirect.password||redirect.hash||redirect.search||redirect.pathname!=="/")
    throw new Error("This app sign-in destination is invalid.");
  return url;
}
